interface CardData {
  icon: string
  title: string
  specialty: string
}

export const topSearchedSpecialtiesData: CardData[] = [
  {
    icon: 'cardiologist-icon.png',
    title: 'Cardiology',
    specialty: 'Cardiology',
  },
  {
    icon: 'orthopedist-icon.png',
    title: 'Orthopedic',
    specialty: 'Orthopedic',
  },
  {
    icon: 'obgyn-icon.png',
    title: 'OB-GYN',
    specialty: 'Obstetrics/Gynecology',
  },
  {
    icon: 'neurologist-icon.png',
    title: 'Neurology',
    specialty: 'Neurology',
  },
  {
    icon: 'urologist-icon.png',
    title: 'Urology',
    specialty: 'Urology',
  },
  {
    icon: 'psychiatrist-icon.png',
    title: 'Psychiatry',
    specialty: 'Psychiatry',
  },
]
